export default {
  logisticsSetting: lang.templateByUuid("UID:P_UDHWN_17E3A78E0580000E","物流公司设置") /* "物流公司设置" */,
  basiclogistic: lang.templateByUuid("UID:P_UDHWN_17E3A78E0580000F","基础物流") /* "基础物流" */,
  diylogistic: lang.templateByUuid("UID:P_UDHWN_17E3A78E05800010","自定义物流") /* "自定义物流" */,
  logistic: lang.templateByUuid("UID:P_UDHWN_17E3A78E05800011","物流") /* "物流" */,
  delContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000081","确定要删除该物流公司的信息吗？") /* "确定要删除该物流公司的信息吗？" */
};
